import { setInitialValues as setInitialValuesForPaymentMethods } from '../../ducks/paymentMethods.duck';

import { stripeCustomer } from '../PaymentMethodsPage/PaymentMethodsPage.duck';

// The one-page settings reuses the state slices of the pages it replaced
// (ProfileSettingsPage, ContactDetailsPage, PasswordChangePage, PaymentMethodsPage and
// ManageAccountPage), so this file only has the loadData call.

// ================ Load data ================ //

/**
 * Fetch a fresh current user with the saved card. A fresh fetch also picks up an email
 * verified in another tab, which the contact details page used to refetch for.
 */
export const loadData = () => dispatch => {
  dispatch(setInitialValuesForPaymentMethods());
  return dispatch(stripeCustomer());
};
